export enum ContentEnum {
  COURSE = "Course",
  CLASS = "Class",
  SUBJECT = "Subject",
  TOPIC = "Topic",
  CHAPTER = "Chapter",
  COURSE_CHAPTER = "CourseChapter",
  KSC_CLUSTER = "KSCCluster",
  KSC = "KSC",
  QUESTION = "Question",
  VIDEO = "Video",
}

export enum SearchContentEnum {
  COURSE = "Course",
  CLASS = "Class",
  SUBJECT = "Subject",
  TOPIC = "Topic",
  CHAPTER = "Chapter",
  KSC_CLUSTER = "KSCCluster",
  KSC = "KSC",
  QUESTION = "Question",
}

export enum QuestionTypeEnum {
  OBJECTIVE = "Objective",
  SUBJECTIVE = "Subjective",
  MULTIPLE_CHOICE = "Multiple Choice",
  NUMERICAL = "Numerical",
  ASSERTION_REASON = "Assertion and Reason",
  COMPREHENSION = "Comprehension",
  MATCH_THE_COLUMN = "MatchTheColumn",
  TRUE_FALSE = "True/False",
}

export enum QuestionLevelIdEnum {
  LEVEL1 = 1,
  LEVEL2 = 2,
}

export enum QuestionTypeIdEnum {
  OBJECTIVE = 1,
  SUBJECTIVE = 2,
  MULTIPLE_CHOICE = 3,
  NUMERICAL = 4,
  ASSERTION_REASON = 5,
  COMPREHENSION = 6,
  MATCH_THE_COLUMN = 7,
  TRUE_FALSE = 8,
}

export enum DifficultyLevelEnum {
  EASY = 1,
  MEDIUM = 2,
  HARD = 3,
}

export enum DifficultyGroupEnum {
  BASIC = "Basic",
  EASY = "Easy",
  NORMAL = "Normal",
  HARD = "Hard",
  TOUGH = "Tough",
}

export enum QuestionLevelIdsEnum {
  LEVEL1 = 1,
  LEVEL2 = 2,
}

export enum QuestionCategoryIdsEnum {
  GENERAL = 1,
  EXAMPLE = 2,
  ASSIGNMENT = 3,
  QUIZ = 4,
  TEST = 5,
  RECOMMENDED = 9,
  INSTITUTE = 10,
}

export enum QuestionSelectorSortEnum {
  DIFFICULTY = 1,
  CONCEPTS = 2,
  NEWEST = 3,
}

export enum QuestionReviewEnum {
  APPROVED = 1,
  REJECTED = 2,
  EDIT_NEEDED = 3,
}

export enum QuestionDisplayTypeEnum {
  HTML = "renderedHtml",
  DESKTOP = "desktopImage",
  MOBILE = "mobileImage",
}

export enum QuestionPdfImageTypeEnum {
  PAGE = "page",
  QUESTION = "question",
  SOLUTION = "solution",
}

export enum QuestionPdfStatusEnum {
  PDF_UPLOADED = 1,
  PDF_PROCESSED = 2,
  PDF_FAILED = 3,
  PDF_VERIFIED = 4,
  IMAGES_EXTRACTED = 5,
  EXTRACTION_FAILED = 6,
  IMAGES_SAVED = 7,
  QUESTION_BANK = 8,
  PDF_ARCHIVED = 9,
}

export enum QuestionBankStatusEnum {
  NEW_QUESTION = 1,
  TYPE_TAGGED = 2,
  PROCESSING_PENDING = 3,
  PROCESSING_FAILED = 4,
  LATEX_CONVERTED = 5,
  CONTENT_TAGGED = 6,
  LATEX_APPROVED = 7,
  REJECTED = 8,
  EDIT_NEEDED = 9,
  FINAL_APPROVED = 10,
}

export enum QuestionBankReviewEnum {
  LATEX_APPROVED = 7,
  REJECTED = 8,
  EDIT_NEEDED = 9,
  FINAL_APPROVED = 10,
}

export enum QrTargetTypeIdEnum {
  PDF = 1,
  PRESENTATION = 2,
  IMAGE = 3,
  VIDEO = 4,
  PLATFORM_LINK = 5,
}

export enum QrImageTypeEnum {
  SIMPLE = 1,
  QR_WITH_TITLE = 2,
  QR_WITH_DETAILS = 3,
}

export enum QrCategoryEnum {
  ANSWER_KEY_WORKBOOK = 1,
  ANSWER_KEY_FEB_EDITION = 9,
  VIDEO_CONCEPT = 4,
  VIDEO_ACTIVITY = 5,
  VIDEO_QUESTION_SOLUTION = 6,
  QUESTION_HINTS = 7,
  CHAPTER_SELF_PRACTICE = 8,
  CHAPTER_BEGINNER_TEST = 10,
  CHAPTER_CHALLENGER_TEST = 11,
  CHAPTER_ADVANCED_TEST = 12,
  CONCEPT_QUIZ = 13,
  CONCEPT_QUIZ_PDF = 14,
}

export enum PreloadedAssignmentCategoryEnum {
  AFFILIATION = 1,
  STUDENT = 2,
}

export enum PreloadedTestCategoryEnum {
  AFFILIATION = 1,
  STUDENT = 2,
  INTERNAL = 3,
}

export enum QuestionReviewPromptCategoryEnum {
  GENERATE_LATEX_QUESTION = "generateLatexQuestion",
  REVIEW_QUESTION = "reviewQuestion",
}

export enum OpenAIResponseReviewStatusEnum {
  NEW = 1,
  APPROVED = 2,
  REJECTED = 4,
}

export enum SavedTemplatesSortEnum {
  CREATED_ON = 1,
  TEST_NAME = 2,
  DURATION = 3,
  DIFFICULTY = 4,
}

export enum QuestionSimilarityTypeIdsEnum {
  DUPLICATE = 1,
  SIMILAR = 2,
}
export enum QuestionSimilarityStatusEnum {
  NEW = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum ManageQrTabsEnum {
  BY_CATEGORY = "By Category",
  BY_CHAPTER = "By Chapter",
}
